import { Pipe, PipeTransform } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';

@Pipe({
  name: 'timeFormat',
  standalone: false
})
export class TimeFormatPipe implements PipeTransform {

  constructor() { }

  transform(time: string, args?: number): string {
    const timePartsWithDays = time ? time.match(/(\d+)\.(\d+)\:(\d+)\:(\d+)/) : '';
    if (timePartsWithDays) {
      const days = parseInt(timePartsWithDays[1] || '0');
      const hours = parseInt(timePartsWithDays[2] || '0');
      const minutes = timePartsWithDays[3] || '00';
      return days > 0 ? args === 2 ? `${days}d ${hours}h` :
        parseInt(minutes) > 0 ? `${days}d ${hours}h ${minutes}m` : `${days}d ${hours}h` :
        hours > 0 ? parseInt(minutes) > 0 ? `${hours}h ${minutes}m` :
          `${hours}h` : `${minutes}m`;
    } else {
      let timeParts = time ? time.match(/(\d+)\:(\d+)\:(\d+)/) : '';
      if (isNullOrUndefined(timeParts)) {
        timeParts = time.match(/(\d+)\:(\d+)/);
      }
      const hours = parseInt(timeParts[1] || '0');
      const minutes = timeParts[2] || '00';
      return parseInt(minutes) > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    }
  }
}
